// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    
export class OpenEstimateRequest {
  userId: string;
  estimateId: string;
  userEmailId: string;
  culture: string;
  isArchive: boolean;
}
